import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import {user} from './user'
import {docs} from './docs'
// import {organizations} from './organizations'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    docs
  },
  state: {
    navActive: false,
    notifications: [],
  },
  getters: {
    hasNotifications(state) {
      return !!state.notifications.length
    }
  },
  mutations: {
    showNav(state) {
      state.navActive = true
    },
    hideNav(state) {
      state.navActive = false
    },
    setNotifications(state, notifications) {
      state.notifications = notifications
    }
  },
  plugins: [createPersistedState({
    paths: ['user']
  })]
})
